"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./styles/styles.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Clock extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPickingHours: true,
      isAm: this.props.value.getHours() < 12,
      currentHour: this.props.value.getHours(),
      currentMinute: this.props.value.getMinutes(),
      currentAmOrPm: this.props.value.getHours() < 13 ? 'AM' : 'PM'
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.currentHour !== this.state.currentHour || prevState.currentMinute !== this.state.currentMinute || prevState.currentHour !== this.state.currentHour || prevState.currentAmOrPm !== this.state.currentAmOrPm) {
      this.props.onTimeChange(this.state);
    }
  }

  digitsHours() {
    const buttons = [];

    for (let i = 1; i < 13; ++i) {
      buttons.push( /*#__PURE__*/_react.default.createElement("button", {
        key: i,
        className: "clock-digit" + " digit" + i,
        style: {
          backgroundColor: this.props.digitsColor,
          color: this.props.fontColor
        },
        onClick: () => {
          this.setState({
            isPickingHours: false,
            currentHour: i
          });
        }
      }, i));
    }

    return buttons;
  }

  pad(n) {
    return n < 10 ? "0" + n : n;
  }

  digitsMinuts() {
    const buttons = [];

    for (let i = 0, k = 5; i < 12; ++i, k += 5) {
      if (k === 60) {
        k = 0;
      }

      ;
      buttons.push( /*#__PURE__*/_react.default.createElement("button", {
        key: i,
        className: "clock-digit" + " digit" + (i + 1),
        style: {
          backgroundColor: this.props.digitsColor,
          color: this.props.fontColor
        },
        onClick: () => {
          this.setState({
            isPickingHours: true,
            currentMinute: k
          });
        }
      }, k));
    }

    return buttons;
  }

  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "clock",
      style: {
        backgroundColor: this.props.backgroundColor
      }
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "TimeSet"
    }, this.state.currentAmOrPm === 'AM' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      className: "ampm",
      onClick: () => this.setState({
        isAm: false,
        currentAmOrPm: 'PM'
      })
    }, "AM")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      className: "ampm",
      onClick: () => {
        this.setState({
          isAm: true,
          currentAmOrPm: 'AM'
        });
      }
    }, "PM")), this.state.currentHour, ":", this.pad(this.state.currentMinute)), /*#__PURE__*/_react.default.createElement("div", {
      className: "hand hour",
      style: {
        transform: "rotateZ(".concat(this.props.value.getHours() * 30 + this.props.value.getMinutes() / 2, "deg)")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "hand min",
      style: {
        transform: "rotateZ(".concat(this.props.value.getMinutes() * 6, "deg)")
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "hand sec",
      style: {
        transform: "rotateZ(".concat(this.props.value.getSeconds() * 6, "deg)")
      }
    }), this.state.isPickingHours ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", this.digitsHours(), " ") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", this.digitsMinuts(), " ")));
  }

}

exports.default = Clock;